import React from 'react';
import { View, StyleSheet, TouchableWithoutFeedback } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../styles';
import RowView from './RowView';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';

export const RadioButton = (props) => {
  return (
    <View style={[styles.radiButton, props.style]}>
      {props.selected ? (
        <View
          style={
            props?.innerSelectedColor
              ? { ...styles.innerRadioButton, backgroundColor: Color.tezNewBlue }
              : styles.innerRadioButton
          }
        />
      ) : null}
    </View>
  );
};

export const RadioInput = (props) => {
  return (
    <TouchableWithoutFeedback onPress={props.onChange}>
      <RowView style={CommonStyles.centerItems}>
        <RadioButton selected={props.selected} />
        <BaseText>{props.label}</BaseText>
      </RowView>
    </TouchableWithoutFeedback>
  );
};

const RadioGroup = (props) => {
  return (
    <View style={[styles.radioGroup, props.style]}>
      {props.items &&
        props.items.map((item, index) => (
          <RadioInput
            key={index}
            selected={props.selected === item.value}
            label={item.label}
            onChange={() => {
              props.onChange(item.value);
            }}
          />
        ))}
    </View>
  );
};

const styles = StyleSheet.create({
  radiButton: {
    height: scale(24),
    width: scale(24),
    borderRadius: scale(12),
    borderWidth: scale(2),
    borderColor: Color.primary,
    ...CommonProperties.mr3,
    ...CommonProperties.centerAlignment,
  },
  innerRadioButton: {
    height: scale(12),
    width: scale(12),
    borderRadius: scale(6),
    backgroundColor: Color.primary,
  },
  radioGroup: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
});

export default RadioGroup;
